import { render } from "./theme28.vue?vue&type=template&id=78974104&scoped=true"
import script from "./theme28.vue?vue&type=script&lang=js"
export * from "./theme28.vue?vue&type=script&lang=js"

import "./theme28.vue?vue&type=style&index=0&id=78974104&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-78974104"

export default script